/** Klassen van laag naar hoog; `low` is de ondergrens van een klasse. */
export type Legend = { low: number; color: string; name: string }[];

/**
 * De klasse van `value`: de hoogste klasse waarvan de ondergrens niet boven
 * de waarde ligt, dus een waarde op een grens hoort bij de hogere klasse.
 * Onder de laagste grens: de laagste klasse.
 */
export const legendElem = (value: number, legend: Legend) =>
  legend.findLast((l) => value >= l.low) ?? legend[0];
